import { render, staticRenderFns } from "./DetailsNeighborhood.vue?vue&type=template&id=6ca30cb8&scoped=true"
import script from "./DetailsNeighborhood.vue?vue&type=script&lang=js"
export * from "./DetailsNeighborhood.vue?vue&type=script&lang=js"
import style0 from "./DetailsNeighborhood.vue?vue&type=style&index=0&id=6ca30cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca30cb8",
  null
  
)

export default component.exports